import React from 'react'
import Header from '../../common/Header'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import Footer from '../../common/Footer'
import { mysoreSightSeeingData } from './tourPackageData'
import DynamicTourSection from '../../sections/CommonSection/DynamicToureSection'

const MysoreSightSeeing = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title="Mysore Sight Seeing" />
            <CommonBreadcrumb items={["Mysore Sight Seeing"]} />
            <DynamicTourSection {...mysoreSightSeeingData} />
            <Footer />
        </>
    )
}

export default MysoreSightSeeing